import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { TaskComponent } from '../task/task.component';

@Component({
    selector: 'app-task-selection-modal',
    templateUrl: './task-selection-modal.component.html',
    styleUrls: ['./task-selection-modal.component.scss']
})
export class TaskSelectionModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChildren(TaskComponent) taskComponents: TaskComponent[];

    @Input() title = '';
    @Input() tasks = [];
    @Input() selectedTasks = [];
    @Input() hasOverlay = true;

    @Output() select = new EventEmitter<any>();

    filter = '';

    constructor() {
    }

    ngOnInit() {
    }

    open(selectedTasks: any[]) {
        if (selectedTasks) {
            this.selectedTasks = [...selectedTasks];
        }
        this.modal.open();

        if (!this.hasOverlay) {
            setTimeout(() => {
                const overlay = document.getElementsByClassName('modal-overlay');
                if (overlay.length > 1) {
                    overlay[1].classList.add('z-minus');
                }
            });
        }
    }

    close() {
        this.modal.close();
        this.reset();
    }

    private reset() {
        this.selectedTasks = [];
    }

    onSearch(event: string) {
        this.filter = event.toLowerCase();
    }

    onSave() {
        this.select.emit({tasks: this.selectedTasks});
    }

    onCancel() {
        this.modal.close();
    }

    handleSelectTask(event: any) {
        const index = this.selectedTasks.findIndex(item => item.id === event.id);

        if (index < 0) {
            return this.selectedTasks.push(event);
        }

        this.selectedTasks = this.selectedTasks.filter(item => item.id !== event.id);
    }

    isSelected(task: any) {
        return !!this.selectedTasks.find(item => item.id === task.id);
    }

    toggleSelectAll() {
        if (this.areAllSelected) {
            this.selectedTasks = this.selectedTasks.filter(
                t => !this.filteredTasks.some(ft => ft.id === t.id)
            );
        } else {
            const filteredNotYetSelected = this.filteredTasks.filter(
                t => !this.isSelected(t)
            );
            this.selectedTasks = [...this.selectedTasks, ...filteredNotYetSelected];
        }
        }

    get selected() {
        return this.selectedTasks;
    }

    get filteredTasks() {
        if (!this.filter) {
            return this.tasks;
        }

        return this.tasks.filter(
            t => t.name.toLowerCase().includes(this.filter)
                || t.description.toLowerCase().includes(this.filter)
                || t.identifier.toLowerCase().includes(this.filter)
        );
    }

    get areAllSelected(): boolean {
        return this.filteredTasks && this.filteredTasks?.length > 0 &&
            this.filteredTasks.every(task => this.isSelected(task));
    }
}
